import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sensorHeader'
})
export class SensorHeaderPipe implements PipeTransform {

  transform(sensorKey: string): string {
    const sensorHeaderPair = {
      'score': 'Awair Score',
      'temp': 'Temperature',
      'humid': 'Humidity',
      'co2': 'CO₂',
      'voc': 'Chemicals',
      'dust': 'Aggregated Dust',
      'pm25': 'PM 2.5',
      'pm10': 'PM 10'
    };

    return sensorHeaderPair[sensorKey] != null ? sensorHeaderPair[sensorKey] : null;
  }
}
